<template>
    <div>
        <!-- Filter Start -->
        <div class="innerBox filter">
            <div class="d-flex flex-row justify-content-between">
                <div><h2 class="page-title">Service Rate</h2></div>
                <div class="d-flex flex-row justify-content-end">
                    <template v-if="user.type !== 'ADMIN_EKSPEDISI'">
                        <div class="mr-3">
                            <MultiSelect
                                v-model="filter.gudang"
                                :options="warehouse.map((x) => x.loc_code)"
                                :deselect-label="''"
                                placeholder="All Warehouse"
                                class="tms-multiselect"
                            />
                        </div>
                        <div class="mr-3">
                            <MultiSelect
                                v-model="filter.region"
                                :options="options.region"
                                :deselect-label="''"
                                placeholder="All Regions"
                                class="tms-multiselect"
                            />
                        </div>
                        <div class="mr-3">
                            <MultiSelect
                                :options="ekspedisi.map((x) => x.id)"
                                :custom-label="
                                    (opt) =>
                                        ekspedisi.find((x) => x.id == opt).kode
                                "
                                placeholder="All Ekspedisi"
                                v-model="filter.ekspedisi"
                                class="tms-multiselect"
                            />
                        </div>
                        <div class="mr-3">
                            <div class="input-group">
                                <flat-pickr
                                    :config="rangePickr"
                                    placeholder="Select Date"
                                    v-model="selected.date"
                                ></flat-pickr>
                                <span
                                    class="input-group-text bg-white"
                                    style="
                                        border-top-left-radius: 0;
                                        border-bottom-left-radius: 0;
                                        border: 0;
                                        box-shadow: 0 0 6px #0000000f;
                                        background-color: #ededed !important;
                                    "
                                >
                                    <i
                                        class="fas fa-calendar"
                                        style="color: black"
                                    ></i>
                                </span>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="mr-3">
                            <MultiSelect
                                v-model="filter.region"
                                :options="options.region"
                                :deselect-label="''"
                                placeholder="All Regions"
                                class="tms-multiselect"
                            />
                        </div>
                        <div class="mr-3">
                            <i class="fas fa-calendar prefix-icon"></i>
                            <div class="prefix-input">
                                <flat-pickr
                                    :config="rangePickr"
                                    placeholder="Select Date"
                                    v-model="selected.date"
                                ></flat-pickr>
                            </div>
                        </div>
                    </template>
                    <a
                        href=""
                        class="btn"
                        style="margin-right: -1rem !important; padding: 0"
                    >
                        <img
                            src="@/assets/img/notification.svg"
                            alt=""
                            style="display: none"
                        />
                    </a>
                </div>
            </div>
        </div>
        <!-- Filter End -->

        <!-- Stats & Chart Start -->
        <div class="row">
            <!-- Stats Plan Alokasi -->
            <div class="col-lg-6 col-md-4 col-6">
                <div
                    class="h-100"
                    style="display: flex; flex-direction: column"
                >
                    <mini-stats
                        title="Plan Alokasi"
                        :value="
                            data.stats != null
                                ? numberWithCommas(data.stats.plant_alokasi)
                                : 'Loading...'
                        "
                        icon="fal fa-clipboard-list"
                        iconColor="#9AF8A2"
                    ></mini-stats>
                </div>
            </div>

            <!-- Stats Delivery Unit -->
            <div class="col-lg-6 col-md-4 col-6">
                <div
                    class="h-100"
                    style="display: flex; flex-direction: column"
                >
                    <mini-stats
                        title="Delivery Unit"
                        :value="
                            data.stats != null
                                ? numberWithCommas(data.stats.delivery_unit)
                                : 'Loading...'
                        "
                        icon="fal fa-truck"
                        iconColor="#F8CFA6"
                    ></mini-stats>
                </div>
            </div>

            <!-- Chart Delivery unit Distribution -->
            <div class="col-lg-12 col-md-8 col-6">
                <div class="innerBox mt-4">
                    <h5 class="section-title">Delivery Unit Distribution</h5>
                    <delivery-unit-distribution
                        :data="
                            data.byDate && data.byDate.length > 0
                                ? transformData(data.byDate)
                                : null
                        "
                    ></delivery-unit-distribution>
                </div>
            </div>

            <!-- Chart Delivery unit Distribution by Region -->
            <div class="col-lg-12 col-md-8 col-6">
                <div class="innerBox mt-4">
                    <div class="title-wrapper">
                        <h5 class="section-title">
                            Delivery Unit Distribution
                        </h5>
                        <div class="title-space"></div>
                        <h3 class="section-title-2">by Region</h3>
                    </div>
                    <chart-delivery-unit-region
                        :data="data.byRegion"
                    ></chart-delivery-unit-region>
                </div>
            </div>

            <!-- Chart Delivery unit Distribution 2 -->
            <div class="col-lg-12 col-md-8 col-6">
                <div class="innerBox mt-4">
                    <div class="title-wrapper">
                        <h5 class="section-title">
                            Delivery Unit Distribution
                        </h5>
                        <div class="title-space"></div>
                        <h3 class="section-title-2">by Expedition</h3>
                    </div>
                    <delivery-unit-distribution-2
                        :data="data.ekspedisiData"
                    ></delivery-unit-distribution-2>
                </div>
            </div>

            <!-- Chart Delivery unit Distribution by Warehouse -->
            <div class="col-lg-12 col-md-8 col-6">
                <div class="innerBox mt-4">
                    <div class="title-wrapper">
                        <h5 class="section-title">
                            Delivery Unit Distribution
                        </h5>
                        <div class="title-space"></div>
                        <h3 class="section-title-2">by Warehouse</h3>
                    </div>
                    <chart-deliveryunitwarehouse
                        :data="data.gudangData"
                    ></chart-deliveryunitwarehouse>
                </div>
            </div>
        </div>
        <!-- Stats & Chart End -->

        <!-- Detail Report Start -->
        <div class="innerBox mt-4">
            <h5 class="section-title">Detail Report</h5>

            <table class="table tms-table" v-if="data.byDate != null">
                <thead>
                    <tr>
                        <th>No.</th>
                        <th>Tanggal</th>
                        <th>Distribution Unit</th>
                        <th>Delivery Unit</th>
                        <th>Achievement (%)</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(singleData, index) in data.byDate">
                        <tr>
                            <td>{{ index + 1 }}.</td>
                            <td>
                                {{
                                    moment(singleData.date).format("DD/MM/YYYY")
                                }}
                            </td>
                            <td>
                                {{ numberWithCommas(singleData.plant_alokasi) }}
                            </td>
                            <td>
                                {{ numberWithCommas(singleData.delivery_unit) }}
                            </td>
                            <td
                                :class="
                                    calcAchievement(
                                        singleData.plant_alokasi,
                                        singleData.delivery_unit
                                    ) == 100
                                        ? 'text-green'
                                        : 'text-orange'
                                "
                            >
                                {{
                                    calcAchievement(
                                        singleData.plant_alokasi,
                                        singleData.delivery_unit
                                    )
                                }}%
                            </td>
                            <td>
                                <!-- <button class="btn btn-secondary" style="background-color: #DBDBDB; color: #6d6d6d; border: none; width: 40px; height:40px; border-radius: 100000px;">
                                    <i class="fal fa-comment-lines"></i>
                                </button> -->

                                <button
                                    class="btn btn-secondary ml-3"
                                    style="
                                        background-color: #f7f7f7;
                                        color: #969696;
                                        border: none;
                                    "
                                    @click="
                                        singleData.isOpen = !singleData.isOpen
                                    "
                                >
                                    <i class="fal fa-list"></i>
                                    See Details
                                    <i
                                        class="fal fa-angle-up"
                                        style="transition: transform 0.2s ease"
                                        :style="
                                            singleData.isOpen
                                                ? {
                                                      transform:
                                                          'rotate(180deg)',
                                                  }
                                                : null
                                        "
                                    ></i>
                                </button>
                            </td>
                        </tr>
                        <template v-if="singleData.isOpen">
                            <tr>
                                <td class="table-title" colspan="6">
                                    Per Plant Detail
                                </td>
                            </tr>
                            <tr class="no-border">
                                <td></td>
                                <td style="color: #bcbcbc; font-weight: normal">
                                    Plant
                                </td>
                                <td colspan="4"></td>
                            </tr>
                            <tr
                                class="no-border"
                                v-for="singleDetail in singleData.details"
                            >
                                <td></td>
                                <td>{{ singleDetail.plant_name }}</td>
                                <td>
                                    {{
                                        numberWithCommas(
                                            singleDetail.plant_alokasi
                                        )
                                    }}
                                </td>
                                <td>
                                    {{
                                        numberWithCommas(
                                            singleDetail.delivery_unit
                                        )
                                    }}
                                </td>
                                <td colspan="2"></td>
                            </tr>
                            <tr
                                class="no-border"
                                v-if="
                                    singleData.details == null ||
                                    singleData.details.length == 0
                                "
                            >
                                <td></td>
                                <td>No Data</td>
                                <td>-</td>
                                <td>-</td>
                                <td colspan="2"></td>
                            </tr>
                            <!-- For spacing only -->
                            <tr class="no-border">
                                <td style="padding: 2.5px" colspan="6"></td>
                            </tr>
                        </template>
                    </template>
                </tbody>
            </table>
            <div
                v-else
                style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 100px 0;
                "
            >
                <h5 class="m-0">Loading...</h5>
            </div>
        </div>
        <!-- Detail Report End -->
    </div>
</template>

<script>
import qs from "qs";
import moment from "moment";
import debounce from "debounce";

import miniStats from "./children/miniStats";
import deliveryUnitDistribution from "./children/deliveryUnitDistribution";
import deliveryUnitDistribution2 from "./children/deliveryUnitDistribution2";
import chartDeliveryUnitRegion from "./children/chartDeliveryUnitRegion";
import chartDeliveryunitwarehouse from "./children/chartDeliveryunitwarehouse"; // Correct the import statement

export default {
    metaInfo: {
        title: "Service Rate",
    },
    data() {
        let startDate = moment().startOf("month").format("YYYY-MM-DD");
        // let startDate = moment().subtract(14, "days").format("YYYY-MM-DD");
        let currentDate = moment().format("YYYY-MM-DD");
        let user = this.$store.getters.currentUser;

        return {
            moment: moment,
            ekspedisi: this.$store.getters.getEkspedisi,
            warehouse: this.$store.getters.getWarehouse,
            user,
            options: {
                region: this.$store.getters.getRegion,
                byDateMonth: [
                    { title: "By Date", value: 1 },
                    { title: "By Month", value: 2 },
                ],
                month: this.$store.getters.getMonth,
                year: this.$store.getters.getYear,
            },
            selected: {
                byDateMonth: 1, // 1 == by date, 2 == by month
                monthYear: {
                    month: parseInt(moment().format("M")),
                    year: moment().format("YYYY"),
                },
                date: `${startDate} to ${currentDate}`,
            },
            filter: {
                region: null,
                start: startDate,
                end: currentDate,
                ekspedisi: null,
                gudang: null,
            },
            rangePickr: {
                mode: "range",
                dateFormat: "Y-m-d",
                altInput: true,
                altFormat: "d M Y",
                altInputClass: "form-control input grey-flatpickr",
                // Make sure there are no restrictions here
            },
            data: {
                stats: null,
                byDate: null,
                ekspedisiData: [],
                byRegion: [],
                gudangData: [],
            },
        };
    },
    components: {
        miniStats,
        deliveryUnitDistribution,
        deliveryUnitDistribution2,
        chartDeliveryUnitRegion,
        chartDeliveryunitwarehouse, // Correct the component registration here
    },
    mounted() {},
    watch: {
        filter: {
            deep: true,
            immediate: true,
            handler: "delayedFetchData",
        },
        "selected.date"() {
            let split = this.selected.date.split(" to ");
            this.filter.start = split[0];
            this.filter.end = split.length > 1 ? split[1] : split[0];
        },
    },
    methods: {
        delayedFetchData: debounce(function () {
            this.fetchData();
        }, 1000),
        fetchData() {
            if (this.filter.region === "All" || this.filter.ekspedisi === 999) {
                this.filter = { ...this.filter, region: null, ekspedisi: null };
            }

            setTimeout(() => {
                this.$http
                    .get(
                        `/api/reports/service-rate-by-ekspedisi?${qs.stringify(
                            this.filter,
                            { skipNulls: true, arrayFormat: "comma" }
                        )}`
                    )
                    .then((resp) => {
                        this.data.ekspedisiData = resp.data.data;
                    });

                //Fetch Stats
                this.$http
                    .get(
                        "/api/reports/service-rate-stats?" +
                            qs.stringify(this.filter, {
                                skipNulls: true,
                                arrayFormat: "comma",
                            })
                    )
                    .then((resp) => {
                        this.data.stats = resp.data.data;
                    })
                    .catch((err) => {
                        console.log(err);
                    });

                // Fetch By Date
                this.$http
                    .get(
                        "/api/reports/service-rate-by-date?" +
                            qs.stringify(this.filter, {
                                skipNulls: true,
                                arrayFormat: "comma",
                            })
                    )
                    .then((resp) => {
                        let data = resp.data.data;

                        //For Detail
                        for (var i in data) data[i].isOpen = false;

                        this.data.byDate = data;
                    })
                    .catch((err) => {
                        console.log(err);
                    });

                //Fetch by Region
                this.$http
                    .get(
                        "/api/reports/service-rate-by-region?" +
                            qs.stringify(this.filter, {
                                skipNulls: true,
                                arrayFormat: "comma",
                            })
                    )
                    .then((resp) => {
                        this.data.byRegion = resp.data.data;
                    })
                    .catch((err) => {
                        console.log(err);
                    });

                //Fetch by Warehouse
                this.$http
                    .get(
                        `/api/reports/service-rate-by-gudang?${qs.stringify(
                            this.filter,
                            { skipNulls: true, arrayFormat: "comma" }
                        )}`
                    )
                    .then((resp) => {
                        this.data.gudangData = resp.data.data;
                    });
            }, 300);
        },

        transformData(input) {
            // Define the unique plant names based on the given input.
            // This ensures that any new plant names in the input will be accounted for in the output.
            // const plantNames = [...new Set(input.flatMap(item => item.details.map(detail => detail.plant_name)))];
            const plantNames = this.$store.getters.getPlant.map(
                (x) => x.plant_name
            );

            const output = input.map((item) => {
                // Initialize the result object with the date.
                const result = { tanggal: moment(item.date).format("DD MMM") };

                plantNames.forEach((plant) => {
                    result[plant] = 0; // delivery_unit
                    result[`plant_alokasi_${plant}`] = 0; // plant_alokasi
                });

                // Set the delivery units and plant alokasi for the plants that exist in the details array.
                item.details.forEach((detail) => {
                    result[detail.plant_name] = parseInt(
                        detail.delivery_unit,
                        10
                    );
                    result[`plant_alokasi_${detail.plant_name}`] = parseInt(
                        detail.plant_alokasi,
                        10
                    );
                });

                return result;
            });

            return output;
        },

        //delivery_unit / plant_alokasi * 100
        calcAchievement(plant_alokasi, delivery_unit) {
            if (delivery_unit == 0) return 0;
            if (
                (plant_alokasi == 0 && delivery_unit > 0) ||
                delivery_unit / plant_alokasi > 1
            )
                return 100;
            return Math.round((delivery_unit / plant_alokasi) * 100);
        },
    },
};
</script>

<style scoped>
.innerBox {
    background-color: white;
    border-radius: 8px;
    box-shadow: 0px 3px 10px #0000000f;
    padding: 10px 20px;
}

.align-middle {
    display: flex;
    align-items: center;
}

.page-title {
    font-size: 27px;
    font-weight: bold;
    margin: 0;
}

.title-wrapper {
    display: flex; /* Use flexbox */
    align-items: baseline; /* Align items along the baseline */
}

.title-space {
    margin-right: 5px; /* Adjust the space by changing the margin */
}

.section-title {
    font-size: 20px;
    font-weight: bold;
    margin: 0;
    color: #4d4d4d;
}

.section-title-2 {
    font-size: 15px;
    font-weight: bold;
    margin: 0;
    color: #4d4d4d;
}

/* tms-table start */
.tms-table {
    width: 100%;
    border-collapse: collapse;
}

.tms-table th,
.tms-table td {
    padding: 8px;
    text-align: left;
    vertical-align: middle;
}

/* Styling for table headers */
.tms-table th {
    color: #bcbcbc;
    font-weight: normal;
    border-bottom: 0px solid #e4e7ea;
}

/* Styling for table data cells */
.tms-table td {
    font-weight: normal;
}

/* Remove top border from first row */
.tms-table tr:first-child td {
    border-top: none;
}
/* tms-table end */

.text-green {
    color: #38b233;
}
.text-orange {
    color: #cb651b;
}
.prefix-icon {
    position: absolute;
    right: 15px;
    top: 20px;
    transform: translateY(-50%);
}

.prefix-input .elegant-flatpickr {
    padding-right: 35px;
}
</style>
